export default "1280px"